import * as React from "react"
import { useState } from "react"

// components
import Icon from "../components/Icon"
import MenuInstitucional from "../components/MenuInstitucional"

// styles
import "../styles/css/styles.css"

// assets
import logo from "../../assets/images/brand/logo.wega.footer.svg"
import wedigi from "../../assets/images/brand/logo.wedigi.svg"

import argentina from "../../assets/images/icons/flag.argentina.svg"

import mail from "../../assets/images/icons/mail.svg"
import phone from "../../assets/images/icons/phone.svg"
import whatsapp from "../../assets/images/icons/whatsapp.svg"
import facebook from "../../assets/images/icons/facebook.svg"
import instagram from "../../assets/images/icons/instagram.svg"
import linkedin from "../../assets/images/icons/linkedin.svg"
import youtube from "../../assets/images/icons/youtube.svg"
import gototop from "../../assets/images/icons/go-to-top.svg"

import applestore from "../../assets/images/icons/apple-store.svg"
import googleplay from "../../assets/images/icons/google-play.svg"






const Footer = () => {

    const handlerText = (e) => {
        e.currentTarget.classList.toggle('open');
    }

    return(
        <footer id="footer">
            <div className="footer-1">
                <div className="container">
                    <img className="logo" src={logo} alt="Wega Motors" />
                    <div className="icons">
                        <ul className="contacts">
                            <li>
                                <Icon link="mailto:sac@wegamotors.com.br" title="SAC" icon={mail} label="sac@wegamotors.com.br" />
                            </li>
                            <li>
                                <Icon link="tel:+5508007421000" title="Telefone Wega" icon={phone} label="0800 742 1000" />
                            </li>
                            <li>
                                <Icon link="https://api.whatsapp.com/send?phone=551122196801&text=Olá, pode me ajudar?" title="Whatsapp Wega" icon={whatsapp} label="(11) 2219-6801" />
                            </li>
                        </ul>
                        <ul className="social">
                            <li>
                                <Icon link="https://www.facebook.com/wegamotorsbr/" title="Facebook Wega" icon={facebook} />
                            </li>
                            <li>
                                <Icon link="https://www.instagram.com/wegamotorsbr/" title="Instagram Wega" icon={instagram} />
                            </li>
                            <li>
                                <Icon link="https://www.linkedin.com/in/wega-motors-brasil-43b25815b/" title="LinkedIn Wega" icon={linkedin} />
                            </li>
                            <li>
                                <Icon link="https://www.youtube.com/wegamotorsbr" title="YouTube Wega" icon={youtube} />
                            </li>
                        </ul>
                        <ul className="language">
                            <li>
                                <Icon link="http://www.wega.com.ar/" title="Wega Argentina" icon={argentina} />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="footer-2">
                <div className="container">
                    <div className="col-1">
                        <div className="col-1" onClick={handlerText}>
                            <strong><span>Institucional</span><br />Wega</strong>
                            <div className="content">      
                                <MenuInstitucional type="institucional" />
                            </div>
                        </div>
                        <div className="col-2" onClick={handlerText}>
                            <strong><span>Dicas</span><br />Técnicas</strong>
                            <div className="content">
                                <MenuInstitucional type="dicas" />
                            </div>
                        </div>
                    </div>
                    <div className="col-2" onClick={handlerText}>
                        <strong><span>Baixe agora</span><br />nosso catálogo</strong>
                        <div className="content">
                            <p>Baixe nosso aplicativo e tenha sempre nosso catálogo atualizado com os últimos lançamentos.</p>
                            <Icon link="https://apps.apple.com/br/app/wega-motors/id1451224639" title="Wega na Apple Store" icon={applestore} />
                            <Icon link="https://play.google.com/store/apps/details?id=br.com.ideia2001.CatalogoWegaMotors&pli=1" title="Wega na Google Play" icon={googleplay} />
                        </div>
                    </div>
                    <div className="col-3" onClick={handlerText}>
                        <strong><span>Conheça nossas</span><br />unidades</strong>
                        <div className="content">
                            <p>
                                <strong>Unidade Itajaí - Matriz</strong>
                                Av. Mário Uriarte, 1060 - Cordeiros - Itajaí/SC<br />
                                CEP: 88311-740
                            </p>
                            <p>
                                <strong>Unidade São Paulo (Comercial e Assistência Técnica)</strong>
                                R. Silva Bueno, 1660 - CJ 301/310 - Ipiranga, São Paulo - SP,<br />04208-001
                            </p>
                            <p>
                                <strong>Fábrica na Argentina</strong>
                                Calle Bolivar, 3441 - Lomas Del Mirador - Buenos Aires<br />
                                CEP: B1752AJM
                            </p>
                        </div>
                    </div>
                </div>
                <div className="footer-3">
                    <div className="container">
                        <span>Wega - Copyright {new Date().getFullYear()} © Todos os direitos reservados</span>
                        <div className="powered-by">
                            <a href="#top"><img className="go-to-top" src={gototop} alt="voltar ao topo" /></a>
                            <a href="https://www.wedigi.com.br" target="_blank" rel="noreferrer"><img src={wedigi} alt="we.digi" /></a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer